import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Recarregar")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Salvar PNG")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Selecione o Layout")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Padrão")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Vertical")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "etiqueta" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_base_layout = _resolveComponent("base-layout")!

  return (_openBlock(), _createBlock(_component_base_layout, {
    "show-back-arrow": "true",
    "page-title": "Pix",
    "page-default-back-link": $setup.backLink
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, { onClick: $setup.reload }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ion_button, { onClick: $setup.savePNG }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ion_select, {
            placeholder: "Selecione o Tipo",
            modelValue: $setup.layout,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.layout) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "labelThree" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "labelFive" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _createTextVNode(" Imprima com " + _toDisplayString($setup.labelSize), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["page-default-back-link"]))
}